import Cookies from "js-cookie"
import _ from "lodash"

export function init() {
	let cookieConsent = Cookies.get('cookieConsent');

	if(!cookieConsent) {
		$('.cookies').removeClass('hidden')
	}

	// close
	$('.cookies-close').on('click', function() {
		setCookie()
	});

	window.addEventListener("scroll", _.debounce(checkScrollCookies, 100), false)
}

function checkScrollCookies() {
  if (window.pageYOffset > 100) {
  	setCookie()
  }
}

function setCookie() {
	$('.cookies').addClass('hidden')
	Cookies.set('cookieConsent', true, { expires: 7 })
}


// WEBPACK FOOTER //
// ./scripts/components/Cookies.js